import type { SxProps, Theme } from '@mui/material'

export const FIXED_TIMESTAMP_SIZE = '0.6875rem'

export const FIXED_EVENT_LABEL_SIZE = '0.75rem'

export const fixedTimestampBaseSx: SxProps<Theme> = {
  fontSize: FIXED_TIMESTAMP_SIZE,
  fontWeight: 400,
  letterSpacing: '0.02em',
}

export const fixedEventLabelBaseSx: SxProps<Theme> = {
  fontSize: FIXED_EVENT_LABEL_SIZE,
  fontWeight: 600,
  letterSpacing: '0.02em',
}
